import { Show, type JSX } from 'solid-js';
import { useAuth } from '../lib/AuthContext';
import { logoSrc } from '../lib/brand';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { Icon } from '../ui/Icon';
import { ErrorAlert } from '../components/states';

export function SignIn(): JSX.Element {
  const auth = useAuth();
  return (
    <div class="signin">
      <Card class="signin__card" variant="elevated" padding="xl">
        <img class="signin__logo" src={logoSrc()} alt="Trask" width="202" height="66" />
        <h1 style={{ 'margin-top': 'var(--space-4)' }}>AI Workbench</h1>
        <p class="signin__lead">
          AI tools running in cloud and machine dedicated to you.
        </p>
        <Show when={auth.error()}>
          <div style={{ 'margin-bottom': 'var(--space-5)', 'text-align': 'left' }}>
            <ErrorAlert title="Sign-in failed" error={auth.error()} />
          </div>
        </Show>
        <Button variant="gradient" size="lg" block onClick={() => auth.signIn()}>
          Sign in
          <Icon name="chevronRight" size={18} />
        </Button>
        <p class="signin__foot">Accounts are provisioned on demand.</p>
      </Card>
    </div>
  );
}
